import Menu from 'components/Menu/index.js'

export default class SecondaryNavigation extends Menu {
  constructor(element) {
    super(element)

    window.addEventListener('click', (event) => {
      if (
        this.target.contains(this.trigger) == false &&
        this.target.contains(event.target) == false &&
        this.trigger.contains(event.target) == false
      ) {
        this.instance.closePopup(false)
      }
    })
  }
}
